<div class="dasboard-layout">
  <div *ngIf="isVisible" class="nav" [ngClass]="{ 'nav-opened': templateService.getIfSidebarOpened() }">
    <hf-custom-sidenav [routes]="templateRoutes"> </hf-custom-sidenav>

    <hf-navigation></hf-navigation>
    <div class="build-container" *ngIf="!isProd && (version$ | async) as version">
      <small class="build-info">
        V{{ version.version }} - Built: {{ version.buildTime | date: 'dd/MM/yyyy HH:ss' }}, Branch: {{ version.branch }}
      </small>
    </div>
  </div>

  <div class="section">
    <router-outlet></router-outlet>

    <div class="dynamic-sidepanes-anchor">
      <div #dynamicSidepanesAnchor></div>
    </div>
  </div>
</div>

<hfc-toast></hfc-toast>
<hfc-dialog></hfc-dialog>
<hf-chatbot *ngIf="canShowChatbot$ | async"></hf-chatbot>
